const storeName = 'store-locator';

const SEARCH_TYPE_POST_OFFICE = 'post-office';
const TAB_NAME_MAP_VIEW = 'map-view';
const PAGINATION_DEFAULT_PAGE_SIZE = 10;
const PAGINATION_DEFAULT_PAGE = 0;

const defaultApiSearchParams = {
    ACCURACY: '0',
    CURRENT_PAGE: '0',
    PAGE_SIZE: '5',
    FIELDS: 'FULL',
};

export {
    storeName,
    SEARCH_TYPE_POST_OFFICE,
    TAB_NAME_MAP_VIEW,
    PAGINATION_DEFAULT_PAGE_SIZE,
    PAGINATION_DEFAULT_PAGE,
    defaultApiSearchParams,
};
